import { Appendix } from "../../../../shared/entities/scripts/appendix";
import { Site } from "../../../../shared/entities/scripts/site";
import { Study } from "../../../../shared/entities/scripts/study";
import { ForecastGraphDataPoint } from "../../forecasts/scripts/forecasts.entities";
import { Participant } from "./enrollment.entities";
import { EnrollmentLookup } from "./enrollment.lookup";
import { IEnrollmentPageData } from "./enrollment.page";
import { extendedColors } from './enrollment.chart-controller';

var Highcharts = require('highcharts/highcharts');
require('highcharts/highcharts-more')(Highcharts);

export class ChartPie {

    constructor(public parent: IEnrollmentPageData) { }

    UpdatePieChart(indices: number[]): void {

        let chartData: any[] = [];
        let showLegend: boolean = true;

        if (indices != undefined) {

            let data: number[] = [];
            if (this.parent.selectedBreakdown == "RECOVER Cohort") { data = this.parent.aggregatedParticipants.RecoverCohort; }
            else if (this.parent.selectedBreakdown == "Age") { data = this.parent.aggregatedParticipants.Age; }
            else if (this.parent.selectedBreakdown == "Race") { data = this.parent.aggregatedParticipants.Race; }
            else if (this.parent.selectedBreakdown == "Ethnicity") { data = this.parent.aggregatedParticipants.Hispanic; }
            else if (this.parent.selectedBreakdown == "Hispanic or Non-White") { data = this.parent.aggregatedParticipants.NonWhiteHispanic; }
            else if (this.parent.selectedBreakdown == "Sex") { data = this.parent.aggregatedParticipants.Sex; }
            else if (this.parent.selectedBreakdown == "SX Cluster: ExInt (Enrolled)") { data = this.parent.aggregatedParticipants.ClusterExInt; }
            else if (this.parent.selectedBreakdown == "SX Cluster: CogDys (Enrolled)") { data = this.parent.aggregatedParticipants.ClusterCogn; }
            else if (this.parent.selectedBreakdown == "SX Cluster: Autonomic (Enrolled)") { data = this.parent.aggregatedParticipants.ClusterAuto; }

            indices.forEach((index: number) => {
                let label: string = "";
                if (this.parent.selectedBreakdown == "RECOVER Cohort" || this.parent.selectedBreakdown == "Ethnicity" || this.parent.selectedBreakdown == "Hispanic or Non-White" || this.parent.selectedBreakdown == "SX Cluster: ExInt (Enrolled)" || this.parent.selectedBreakdown == "SX Cluster: CogDys (Enrolled)" || this.parent.selectedBreakdown == "SX Cluster: Autonomic (Enrolled)") {
                    label = EnrollmentLookup.GetYesNo(index);
                    if (this.parent.selectedBreakdown == "Ethnicity" && label != "Unknown") {
                        label = (label == "Yes") ? "Hispanic" : "Not Hispanic";
                    }
                }
                else if (this.parent.selectedBreakdown == "Sex") {
                    label = EnrollmentLookup.GetSex(index);
                }
                else if (this.parent.selectedBreakdown == "Age") {
                    label = EnrollmentLookup.GetAgeGroup(index);
                }
                else if (this.parent.selectedBreakdown == "Race") {
                    label = EnrollmentLookup.GetRace(index);
                }

                chartData.push({ name: label, y: data[index], className: ChartPie.GetClassName(label) });
            });
        }
        else { //an "All Participants" view
            let remainingLabel: string = "Total";
            let countFound: number = 0;

            if (this.parent.selectedAggregation == "Overall") {
                chartData.push({ name: 'Participants', y: this.parent.selectedParticipants.length, className: ChartPie.GetClassName("TOTAL") });

                //if 'All Participants', show forecasted
                if (this.parent.selectedBreakdown == "All Participants" && this.parent.selectedForecastRandomized.length > 0) {
                    chartData.push({ name: 'Total Target Remaining', y: this.getTargetRemaining(this.parent.selectedParticipants.length), className: ChartPie.GetClassName("TARGET") });
                }
            }
            else if (this.parent.selectedAggregation == "ByStudy") {
                this.parent.allStudies.forEach((s: Study) => {
                    let count: number = this.parent.selectedParticipants.filter((p: Participant) => p.StudyId == s.Id).length;
                    if (count > 0) {
                        chartData.push({ name: s.Name, y: count, className: ChartPie.GetClassName(s.Name) });
                        countFound += count;
                    }
                });
                if (chartData.length == 1) {
                    remainingLabel = chartData[0].name;                    
                }
                chartData.push({ name: remainingLabel + " Target Remaining", y: this.getTargetRemaining(countFound), className: ChartPie.GetClassName("TARGET") });
            }
            else if (this.parent.selectedAggregation == "ByAppendix") {
                let appendicies = this.parent.allAppendices;
                if (this.parent.showUnassigned) {
                    appendicies = appendicies.concat(this.parent.unassignedAppendicies);
                }
                appendicies.forEach((a: Appendix) => {
                    let count: number = this.parent.selectedParticipants.filter((p: Participant) => p.AppendixId == a.Id).length;
                    if (count > 0) {
                        chartData.push({ name: a.Name, y: count, className: ChartPie.GetClassName(a.Name) });
                        countFound += count;
                    }
                });
                if (chartData.length == 1) {
                    remainingLabel = chartData[0].name;
                }
                chartData.push({ name: remainingLabel + " Target Remaining", y: this.getTargetRemaining(countFound), className: ChartPie.GetClassName("TARGET") });
            }
            else if (this.parent.selectedAggregation == "BySite") {
                let colorIdx: number = 0;
                this.parent.consentedSites.forEach((s: Site) => {
                    let color = extendedColors[colorIdx % extendedColors.length];
                    let classname = "PieStyle-" + color.replace("#", "");
                    chartData.push({ name: s.Name, y: this.parent.selectedParticipants.filter((p: Participant) => p.SiteNumber == s.Id).length, className: classname });
                    document.styleSheets[0].insertRule("." + classname + " {fill: " + color + "; stroke: " + color + "; }", 0);
                    document.styleSheets[0].insertRule("." + classname + ".highcharts-point {fill: " + color + "; stroke: " + color + "; }", 0);
                    colorIdx++;
                });

                showLegend = false;
            }

        }

        this.updateChart(chartData, showLegend);
    }


    updateChart(data: any[], showLegend: boolean = true): void {

        //eventually should not need to use CSS to stle this
        //$('#chart-display').removeClass('piestyle-yes-no piestyle-age piestyle-sex piestyle-race piestyle-all-overall piestyle-all-bystudy piestyle-all-byappendix');

        //if (displayStyle != "") { $('#chart-display').addClass(displayStyle); }

        Highcharts.chart('enrollment-chart', {
            chart: {
                type: 'pie',
                //styledMode: false //this seems to be ignored either way
            },
            title: {
                text: undefined
            },
            tooltip: {
                //pointFormat: '{point.percentage:.0f}% (n={point.y:,.0f})',
                shared: false,
                formatter: function () {
                    //return '<div class="tooltip" style="border-color:' + this.point.color + ';"><b>' + this.point.name + '</b><br/>' + Highcharts.numberFormat(this.point.percentage, 0, '', ',') + '% (n=' + Highcharts.numberFormat(this.point.y, 0, '', ',') + ')</div>';                    
                    return '<b>' + this.point.name + '</b><br>' + Highcharts.numberFormat(this.point.percentage, 0, '', ',') + '% (n=' + Highcharts.numberFormat(this.point.y, 0, '', ',') + ')';
                },
                borderColor: 'black'
            },
            credits: { enabled: false },
            plotOptions: {
                pie: {
                    allowPointSelect: false,
                    cursor: 'pointer',
                    dataLabels: {
                        connectorWidth: 1,
                        connectorShape: 'crookedLine',
                        crookDistance: '0%',
                        //enabled: false,
                        format: '<b>{point.name}</b><br>{point.percentage:.0f}% (n={point.y:,.0f})',
                        //distance: -50,
                        style: {
                            fontWeight: 'normal',
                            fontSize: '13px'
                        },
                        filter: {
                            property: 'percentage',
                            operator: '>',
                            value: 0
                        }
                    },
                    showInLegend: true
                }
            },
            series: [{
                colorByPoint: true,
                type: 'pie',
                data: data,
            }],
            legend: {
                enabled: showLegend
            }
        });
    }

    private getTargetRemaining(enrolledCount: number): number {
        let total: number = 0;
        this.parent.selectedForecastRandomized.forEach((x: ForecastGraphDataPoint) => total += x.Count);
        total = total - enrolledCount;
        if (total < 0) total = 0;
        return total;
    }

    static GetClassName(value: string): string {
        //if (value == "TOTAL") { return "piestyle-lightblue"; }
        if (value == "TOTAL") { return "piestyle-safronyellow"; }
        else if (value == "VITAL") { return "piestyle-airblue"; }
        else if (value == "NEURO") { return "piestyle-safronyellow"; }
        else if (value == "SLEEP") { return "piestyle-cambridgeblue"; }
        else if (value == "AUTONOMIC") { return "piestyle-mountbattenpink"; }
        else if (value == "ENERGIZE") { return "piestyle-sandybrownorange"; }
        else if (value == "TARGET") { return "piestyle-darkgray"; }
        else if (value == "VITAL-1 (Paxlovid)") { return "piestyle-airblue"; }
        else if (value == "NEURO-1 (tDCS & BrainHQ)") { return "piestyle-safronyellow"; }
        else if (value == "AUTONOMIC-1 (IVIG)") { return "piestyle-mountbattenpink"; } //A288A6
        else if (value == "AUTONOMIC-2 (Ivabradine)") { return "piestyle-cambridgeblue"; } //99C2A2
        else if (value == "SLEEP-1 (Modafinil/Solriamfetol)") { return "piestyle-sandybrownorange"; } //f4a261
        else if (value == "SLEEP-2 (Melatonin/Light)") { return "piestyle-resedagreen"; } //666B41
        else if (value == "ENERGIZE-1 (Cardiopulmonary Rehab)") { return "piestyle-rosetaupe"; } //A26B73
        else if (value == "ENERGIZE-2 (Structured Pacing)") { return "piestyle-paynesgray"; } //4D6C80
        else if (value == "AUTONOMIC-Unassigned") { return "piestyle-unassignedpink"; } //635366
        else if (value == "VITAL-Unassigned") { return "piestyle-unassignedblue"; }
        else if (value == "NEURO-Unassigned") { return "piestyle-unassignedyellow"; }
        else if (value == "Yes") { return "piestyle-airblue"; }
        else if (value == "No") { return "piestyle-safronyellow"; }
        else if (value == "Unknown") { return "piestyle-gray"; }
        else if (value == "Hispanic") { return "piestyle-airblue"; }
        else if (value == "Not Hispanic") { return "piestyle-safronyellow"; }
        else if (value == "Female") { return "piestyle-airblue"; }
        else if (value == "Male") { return "piestyle-safronyellow"; }
        else if (value == "Intersex") { return "piestyle-cambridgeblue"; }
        else if (value == "Prefer Not To Answer") { return "piestyle-mountbattenpink"; }
        else if (value == "18-45") { return "piestyle-safronyellow"; }
        else if (value == "46-65") { return "piestyle-airblue"; }
        else if (value == "+65") { return "piestyle-cambridgeblue"; }
        //else if (value == "+70") { return "piestyle-mountbattenpink"; }
        else if (value == "AIAN") { return "piestyle-sandyorange"; }
        else if (value == "Asian") { return "piestyle-mountbattenpink"; }
        else if (value == "Black") { return "piestyle-airblue"; }
        else if (value == "MENA") { return "piestyle-chestnutred"; }
        else if (value == "NHPI") { return "piestyle-ceruleanblue"; }
        else if (value == "Multi") { return "piestyle-cambridgeblue"; }
        else if (value == "White") { return "piestyle-safronyellow"; }
        else return "piestyle-chestnutred";
    }    
}
